export default __webpack_public_path__ + "static/media/12-Sanchit-Dawar.60c3f49e.png";